import { render, staticRenderFns } from "./item-box.vue?vue&type=template&id=1571ab93&scoped=true&"
import script from "./item-box.vue?vue&type=script&lang=ts&"
export * from "./item-box.vue?vue&type=script&lang=ts&"
import style0 from "./item-box.vue?vue&type=style&index=0&id=1571ab93&scoped=true&lang=scss&"
import style1 from "./item-box.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1571ab93",
  null
  
)

export default component.exports